module.exports = __webpack_public_path__ + "img/no-items-found-136px.de18282.webp";